import { partnerFormDependencyConfig } from '../../config/partnerFormConfig';
import { partnerFormDependencyConfigWithDaReChanges } from '../../config/partnerFormConfigWithDaReChanges';
export const getAllChildrenQuestions = useConfigWithDareChanges => {
  const updatedPartnerFormQuestionsConfig = useConfigWithDareChanges ? partnerFormDependencyConfigWithDaReChanges : partnerFormDependencyConfig;
  const childQuestions = {};
  updatedPartnerFormQuestionsConfig.forEach(_ref => {
    let {
      dependencies
    } = _ref;
    dependencies.forEach(option => {
      for (const obj in option) {
        option[obj].forEach(childQ => childQuestions[childQ.key] = {
          level: childQ.level,
          occurance: 0
        });
      }
    });
  });
  return childQuestions;
};
export const getChildrenOfAParentQuestion = (key, optionValue, useConfigWithDareChanges) => {
  const updatedPartnerFormQuestionsConfig = useConfigWithDareChanges ? partnerFormDependencyConfigWithDaReChanges : partnerFormDependencyConfig;
  const childQuestions = [];
  const parentQuestion = updatedPartnerFormQuestionsConfig.find(question => question.key === key);
  parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.dependencies.forEach(dependency => {
    if (dependency[optionValue]) childQuestions.push(...dependency[optionValue]);
  });
  return childQuestions;
};